
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gcvqiE97G9zShb6Pk94mKXiTsXU7a4bolJrf4UomOSygMeta } from "/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index27k0fV4ubZSCZkPTDk1ukG5_45BuTLbSnpf1IzMO3g6QsMeta } from "/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchkyGuh5snIX_GizA7UHwO70v_45lgittZJf3zwEelYXU1EMeta } from "/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexHHHyxpOPmm1C5cRBb4dP_45Z8hgro66gNzLSUDPZfqXXUMeta } from "/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93YkG_mG_kEUHw4EHcuTZaiHZO20ogag3otmtlqHX6FXQMeta } from "/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexu9O4vIO8ztocZ8pdpmpbtZj7BMKxIXDff1_VRvdo97kMeta } from "/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93_45HaGzu7KX_tqV3kz2LL9mV26zpdc7udg1mTI22A1LGMMeta } from "/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index7ZhlM4DIuqBoGJj0XUyBCDxnbTaWkNCYrRe07vkDiD4Meta } from "/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93aOu_45COIPPK1XGPsHXXJQ2xb2IbfnZQTXxBwjgODZ_NMMeta } from "/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index2p9TYGqlVbXTAu_45TluQbE_4545Po3J9zrXmu1OVbPpAnMMeta } from "/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexjUTG_452_paFFzwhVLDYxqnVeOK4j7ylZrMc0QBZ6ip_45oMeta } from "/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexu9O4vIO8ztocZ8pdpmpbtZj7BMKxIXDff1_VRvdo97kMeta || {},
    component: () => import("/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index7ZhlM4DIuqBoGJj0XUyBCDxnbTaWkNCYrRe07vkDiD4Meta || {},
    component: () => import("/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index2p9TYGqlVbXTAu_45TluQbE_4545Po3J9zrXmu1OVbPpAnMMeta || {},
    component: () => import("/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexjUTG_452_paFFzwhVLDYxqnVeOK4j7ylZrMc0QBZ6ip_45oMeta || {},
    component: () => import("/codebuild/output/src3159857110/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]